import dynamic from "next/dynamic";

export const SupportTips = dynamic(() => import("./SupportTips"), {
  ssr: false
});
